import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCRMAuth } from '../../context/CRMAuthContext';

const CRMLogin = () => {
  const navigate = useNavigate();
  const { crmLogin } = useCRMAuth();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const user = await crmLogin(form.username, form.password);
      navigate(user.role === 'admin' ? '/crm/dashboard' : '/crm/requests');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', backgroundColor: '#1a365d',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        backgroundColor: 'white', borderRadius: '16px', padding: '2.5rem 2rem',
        width: '360px', boxShadow: '0 8px 40px rgba(0,0,0,0.3)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ fontSize: '1.5rem', fontWeight: '800', color: '#1a365d' }}>AdvokatTop</div>
          <div style={{ fontSize: '0.9rem', color: '#718096', marginTop: '0.25rem' }}>CRM тизими</div>
        </div>

        {error && (
          <div style={{ backgroundColor: '#fed7d7', color: '#c53030', padding: '0.75rem', borderRadius: '8px', marginBottom: '1rem', fontSize: '0.9rem' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div>
            <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#4a5568', marginBottom: '0.4rem' }}>
              Фойдаланувчи номи
            </label>
            <input
              type="text"
              value={form.username}
              onChange={e => setForm(p => ({ ...p, username: e.target.value }))}
              required
              style={{ width: '100%', padding: '0.7rem 0.9rem', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '0.95rem', boxSizing: 'border-box' }}
            />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#4a5568', marginBottom: '0.4rem' }}>
              Парол
            </label>
            <input
              type="password"
              value={form.password}
              onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
              required
              style={{ width: '100%', padding: '0.7rem 0.9rem', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '0.95rem', boxSizing: 'border-box' }}
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{
              backgroundColor: loading ? '#a0aec0' : '#1a365d', color: 'white', border: 'none',
              padding: '0.85rem', borderRadius: '8px', fontSize: '1rem', fontWeight: '700',
              cursor: loading ? 'not-allowed' : 'pointer', marginTop: '0.5rem',
            }}
          >
            {loading ? 'Кириш...' : 'Кириш'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CRMLogin;
